import React from 'react'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'

const ResponseWithDocuments = ({ response, children }) => {
  const { answer } = response
  return (
    <>
      <SanitizedHTML className="body grui mb-6" html={answer} />
      {children}
      {/* {!!docsLength && (
        <div css={text.styles.textXs}>
          <div
            css={[divider.styles.primary, styles.divider]}
            className="grui my-10 -ml-10 -mr-10"
            role="separator"
          />
          <div className="grui mb-3" css={text.styles.fontMedium}>
            {`${docsLength} Relevant ${pluralize(docsLength, 'source')} found:`}
          </div>
          {suggestedDocs.map(doc => (
            <div
              key={doc.metadata.id}
              css={styles.docItem}
              className="grui mt-2 flex items-center"
            >
              {doc.metadata.knowledge_base_id ? (
                <Book width="12" height="12" />
              ) : (
                <MessagesBubble width="12" height="12" />
              )}
              <Link to={doc.metadata.url} target="_blank" className="grui ml-5">
                {doc.metadata.title}
              </Link>
            </div>
          ))}
        </div>
      )} */}
    </>
  )
}

export default ResponseWithDocuments
